<template>
    <modal
        :is-open="isOpen"
        :is-loading="loading"
        :disabled="loading"
        title="Новый список"
        btn-save-title="Сохранить"
        @onCloseModal="closeModal"
        @onSaveModal="confirmModal"
    >
        <div class="cabinet-form-group">
            <label for="name" class="cabinet-form-group__label required"
                >Название списка</label
            >
            <input
                id="name"
                v-model="listName"
                type="text"
                :class="{ error: isError }"
                class="cabinet-form-group__input"
                placeholder="Новая закупка на январь"
                @input="isError = false"
            />
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Elements/Modal'

export default {
    name: 'RemoveListModal',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            listName: '',
            isError: false
        }
    },
    methods: {
        closeModal() {
            this.listName = ''
            this.$emit('onClose')
        },
        confirmModal() {
            if (!this.listName) {
                this.isError = true
                return
            }

            this.$emit('onConfirm', this.listName)
        }
    }
}
</script>
